<template>
    <div>
        <vuestic-widget :header-text="'Inicio'">
            <h1>Home</h1>
        </vuestic-widget>
    </div>
</template>

<script>
  import VuesticWidget from '../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget'
  export default {
    name: 'home',
    components: { VuesticWidget },
  }
</script>

<style scoped>

</style>
